import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { About } from './pages/About';
import { Team } from './pages/Team';
import { Impact } from './pages/Impact';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Contact } from './pages/Contact';
import { StudentsProgram } from './pages/StudentsProgram';
import { TeachersProgram } from './pages/TeachersProgram';
import { SchoolsPartnerships } from './pages/SchoolsPartnerships';
function App() {
  return <Router data-id="element-0">
      <div className="min-h-screen flex flex-col" data-id="element-1">
        <Navigation data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
            <Route path="/team" element={<Team data-id="element-10" />} data-id="element-9" />
            <Route path="/impact" element={<Impact data-id="element-12" />} data-id="element-11" />
            <Route path="/blog" element={<Blog data-id="element-14" />} data-id="element-13" />
            <Route path="/blog/:slug" element={<BlogPost data-id="element-16" />} data-id="element-15" />
            <Route path="/contact" element={<Contact data-id="element-18" />} data-id="element-17" />
            <Route path="/programs/students" element={<StudentsProgram data-id="element-20" />} data-id="element-19" />
            <Route path="/programs/teachers" element={<TeachersProgram data-id="element-22" />} data-id="element-21" />
            <Route path="/schools-partnerships" element={<SchoolsPartnerships data-id="element-24" />} data-id="element-23" />
          </Routes>
        </main>
        <Footer data-id="element-25" />
      </div>
    </Router>;
}
export { App };